export * from './vikkon-table.module';
export * from './vikkon-table.component';